import Box from "@mui/material/Box";
import { CustomButton } from "../../../../../components/customButton/CustomButton";
import toast from "react-hot-toast";

export function TabProfesionalHeader({
  handleClickVisitaCero,
  handleOpenDialog,
  allowedWrite,
  showVisitaCero,
  showEquipo,
  cambioDireccion
}) {
  const validarGeoPaciente = () => {
    if (cambioDireccion)
      toast.error("El paciente no se encuentra correctamente geoposicionado, por favor dirigirse a la pestaña Ubicaciones para actualizar la información.");
    else
      handleOpenDialog("addProfessional");
  }
  
  return (
    <Box display="flex" justifyContent="space-between" alignItems="center">
      <h3>Profesionales</h3>
      <Box display="flex" gap="20px">
        {(showVisitaCero != 0) && <CustomButton
          label={"Visita cero"}
          variant="outlined"
          disabled={!allowedWrite && (showVisitaCero != 2)}
          onClick={handleClickVisitaCero}
        />}
        {showEquipo && <CustomButton
          label={"Ver equipo"}
          variant="outlined"
          disabled={false}
          onClick={() => handleOpenDialog("viewEquipo")}          
        />}
        <CustomButton
          label={"Actualizar honorarios"}
          variant="outlined"
          disabled={!allowedWrite}
          
          onClick={() => handleOpenDialog("updateHonorarios")}
        />
        <CustomButton
          label={"Agregar  profesional"}
          disabled={!allowedWrite}
          onClick={() => validarGeoPaciente()}
        />
      </Box>
    </Box>
  );
}
